import { AbilityBuilder } from '@casl/ability'

import { AppAbility } from '.'
import { User } from './models'
import { Role } from './roles'

type PermissionsByRole = (
  user: User,
  builder: AbilityBuilder<AppAbility>,
) => void

export const permissions: Record<Role, PermissionsByRole> = {
  ADMIN(_, { can }) {
    can('manage', 'all')
  },
  USER(user, { can }) {
    can('update', 'Order', ['status'], { tech_user_id: { $eq: user.id } })
    can('update', 'Call', ['status'], { userId: { $eq: user.id } })
    can('read', 'Asset')
    can(['create'], 'OrderReport')
    can(['readMyCalls'], 'Call')
    can(['create'], 'CallItem')
    can(['create'], 'CallReport')
    can(['create', 'delete'], 'CallReportAttachment')
    can(['read'], 'Storage')
    can(['checkin', 'checkout'], 'StorageTransaction')
  },
  GUEST() {},
}
